import React, { useEffect, useState } from "react";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import HeroBg from "../components/HeroBg/HeroBg";
import Loader from "../components/Loader/Loader";
import { projects } from "./data";
import Meta from "../components/Meta";

function Work() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Meta
        title="VITRI ENTERPRISES"
        description="Take a look at VITRI ENTERPRISES' completed projects across Gujarat, including CCTV installations, boom barriers, networking setups, and access control systems for homes and businesses."
        keywords="security project portfolio, Gujarat CCTV installations, boom barrier projects, access control systems, completed work VITRI ENTERPRISES"
        canonical="https://vitrienterprises.in/work"
      />

      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <HeroBg title={"Our Work"} />
          <section>
            <div className="our-work-container">
              <div className="projects">
                {projects.map((project, index) => (
                  <div
                    key={project.id}
                    className={`project-card ${
                      index % 2 === 0 ? "reverse" : ""
                    }`}
                  >
                    <div className="project-content">
                      <h2>{project.name}</h2>
                      <h4>{project.location}</h4>
                      <p>{project.about}</p>
                    </div>
                    <div className="project-image">
                      <img src={project.image} alt={project.name} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <Footer />
        </>
      )}
    </div>
  );
}

export default Work;
